<template>
  <div v-if="matDetail.id" class="detail_box">
    <HeaderFixed v-if="isShowHeaderTopFixed" :matDetail="matDetail" :download="downloadMatCheck" />
    <!-- 分类面包屑 -->
    <div class="detail_bread"><Bread :backName="'返回'" :list="breadArr" /></div>
    <!-- 内容 -->
    <div class="detail_content">
      <div ref="parent" class="content_left">
        <div class="content_img">
          <h2 class="left_title">
            <em v-if="matDetail.pay_type === 0" class="left_title_free" />
            <em v-else class="left_title_vip" />
            <p>{{ matDetail.name }}</p>
          </h2>
          <div class="model_detail" :style="`height: ${imgLess ? '500px': ''}`">
            <img :src="matDetail.big_img + detailImgRule" alt="detail_img">
            <div v-show="!isLoginedIn" class="detail_mast">
              <div class="mast_btn_box" @click="lookMoreBtn">
                <p class="mast_btn"><span>登录解锁查看全部图片</span><em class="icon_detail_down" /></p>
              </div>
            </div>
          </div>
        </div>
        <!-- 相关推荐 -->
        <div v-show="matList.slice(30).length" class="detail_recommend">
          <h3 class="recommend_title">相关推荐</h3>
          <div
            v-reportActionScroll class="recommend_box" pos="" :area="4"
            :classid="matDetail.class_id" :templateId="matDetail.id" :templateName="matDetail.name" :templateType="reportType(matDetail.pay_type)">
            <ModelItem
              v-for="item in matList.slice(30)" :key="item.id" size="middle" :imgRule="smallImgRule960"
              class="recommend_item" :item="{ title: item.name, img: item.small_img, url: `/detail?${MatId}=${item.id}` }" @click.native="report(item.name, 4)" />
          </div>
        </div>
      </div>
      <!-- 左侧 -->
      <div class="content_right">
        <!-- 模板详情信息 -->
        <div ref="targetTop" class="content_info">
          <!-- 下载 -->
          <div class="right_down">
            <Button class="down_btn" @click="clickDownloadBtn"><em class="icon_down white" />{{ `${matDetail.pay_type === 0 ? '免费下载' : '立即下载'}` }}</Button
            >
          </div>
          <!-- 版权 -->
          <div class="top_line font_box">
            <div class="font_item"><label class="label">更新日期:</label><p class="font">{{ formatDate(matDetail.upload_time) }}</p></div>
            <div class="font_item"><label class="label">商用说明:</label><p class="font">{{ '限个人商用' || matDetail.commercial_desc }}</p></div>
            <div class="font_item"><label class="label">资源格式:</label><p class="font">{{ matDetail.format }}</p></div>
            <div class="font_item"><label class="label">资源作者:</label><p class="font">{{ matDetail.author || '完美办公' }}</p></div>
          </div>
          <!-- 相关标签 -->
          <div class="top_line font_box">
            <h5>相关标签:</h5>
            <ul class="label_box">
              <li
                v-for="(name, index) in getLabel(matDetail.tags)" :key="index" class="label_item">
                <a
                  class="ellipsis_one" :href="`/search?keyword=${encodeURIComponent(name)}`"
                  @click="report(name, 2)">{{ name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- 猜你喜欢 -->
        <div v-show="likeList.length" ref="target" class="detail_like">
          <div class="like_header">
            <h3 class="title">猜你喜欢</h3>
            <div class="switch">
              <IconArrow
                :width="10" :height="14" class="icon left"
                @click.native="likeSwitchLeft" />
              <IconArrow
                :width="10" :height="14" class="icon right"
                @click.native="likeSwitchRight" />
            </div>
          </div>
          <ul
            v-reportActionScroll class="recommend_box" pos="" :area="3">
            <ModelItem
              v-for="item in likeList" :key="item.id" size="small" class="like_item"
              :imgRule="smallImgRule960" :item="{ title: item.name, img: item.small_img, url: `/detail?${MatId}=${item.id}` }" @click.native="report(item.name, 3)" />
          </ul>
        </div>
      </div>
    </div>
    <TransitionAm><DownloadLimitDialog v-if="downloadLimitDialog" @clickClose="downloadLimitDialog = false" @clickUnlock="clickDownloadLimitDialogUnlock" /></TransitionAm>
  </div>
</template>

<script>
import ModelItem from '@/components/ModelItem/index.vue'
import Bread from '@/components/Bread/index.vue'
import IconArrow from '@/components/Icons/IconArrow.vue'
import HeaderFixed from '@/views/Detail/HeaderFixed.vue'
import TransitionAm from '@/components/TransitionAm/index.vue'
import DownloadLimitDialog from '@/views/common/DownloadLimitDialog.vue'

import Button from '@shared/components/Button/Button.vue'

import { strictExtend, formatDate } from '@shared/utils/base/index.js'
import { Cat1, Cat2, Cat3, Sort, MatId, limitDownloadCode } from '@/common/const.js'
import api from '@/api'
import { retCode } from '@/api/bussinessCode.js'
import { getSource } from '@/common/cache.js'
import { detailImgRule, smallImgRule960 } from '@/common/resources.js'
import { ClientDownload } from '@/api/clientApi.js'

import { reportLoad, reportDownload, reportAction } from '@/report/index.js'

const Level1 = 'class1_id'
const Level2 = 'class2_id'
const Level3 = 'class_id'

export default {
  name: 'Detail',

  components: { Bread, ModelItem, Button, IconArrow, HeaderFixed, TransitionAm, DownloadLimitDialog },

  data () {
    return {
      MatId,
      smallImgRule960,
      detailImgRule,
      breadArr: [],
      likeActive: 0,
      isShowHeaderTopFixed: false,

      // 下载次数超过限制
      downloadLimitDialog: false,
      // 控制顶部的上报展示，只上报一次
      isHeaderTopShowReport: false,
      imgLess: true
    }
  },

  computed: {
    matList () {
      const list = this.$store.state.matList
      return this.randomList(strictExtend(list))
    },
    matDetail () {
      return this.$store.state.matDetail
    },
    matStatistic () {
      return this.$store.state.matStatistic
    },
    categoryList () {
      return this.$store.state.operational.categoryArr
    },
    isVip () {
      return this.$store.getters.isVip
    },
    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    },
    likeList () {
      const page = 10 * this.likeActive
      return this.matList.slice(page, 10 + page)
    },
    detailAD () {
      // cat1=16、cat2=197的广告
      const level1 = this.matDetail[Level1]
      const level2 = this.matDetail[Level2]

      if (level1 !== 16 || level2 !== 197) { return false }

      return true
    },

    likeActiveMax () {
      // floor 因为下标0开始
      return Math.floor(this.matList.slice(0, 30).length / 10)
    }
  },

  watch: {
    isLoginedIn (flag) {
      if (flag) {
        this.imgLess = false
      } else {
        this.imgLess = true
      }
    }
  },

  created () {
    const params = { data: { [MatId]: Number(this.$route.query[MatId]) } }

    this.$store.dispatch('getMatDetail', params).then(() => {
      this.initMethods()
    })

    const matDetail = this.$store.state.matDetail
    // 所有模板挂在3级分类下面，不用考虑3级分类不存在的情况
    const matListParams = {
      [Cat1]: matDetail[Level1],
      [Cat2]: matDetail[Level2],
      [Cat3]: matDetail[Level3],
      [Sort]: 1,
      page: 1,
      size: 46
    }

    // 猜你喜欢的规则：该3级分类的综合排序模板，随机打乱，详情数据携带123级分类id
    this.$store.dispatch('getMatList', { data: matListParams })
  },

  mounted () {
    window.addEventListener('scroll', this.handleWindowScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleWindowScroll)
  },

  methods: {
    initMethods () {
      this.templateReport = {
        template_name: this.matDetail.name,
        template_id: this.matDetail.id,
        template_type: this.reportType(this.matDetail.pay_type)
      }

      reportLoad({ pagetype: 4 })
      this.report('', 0, 1)

      this.setDefaultImgHeight()
      this.computedBread()
    },

    clickDownloadLimitDialogUnlock () {
      this.downloadLimitDialog = false
      this.$store.commit('report/setGlobalBuyDialog', { renewtype: 1 })
      this.$store.commit('buyDialogVisible', true)
    },

    report (pos = '', area = 0, type = 2) {
      reportAction({ actiontype: type, area, pos, classid: this.matDetail.class_id, ...this.templateReport })
    },

    reportType (type) {
      return type === 0 ? 'free' : 'member'
    },

    setDefaultImgHeight () {
      this.imgLess = !this.isLoginedIn
    },

    formatDate (time) {
      if (typeof time !== 'number') {
        return ''
      }
      return formatDate(time * 1000, 'yyyy-MM-dd')
    },

    lookMoreBtn () {
      this.report('', 5)
      this.$store.commit('loginDialogVisible', true)
    },

    // 洗牌
    randomList (list) {
      list.forEach((it, index) => {
        const randomIndex = Math.floor(Math.random() * list.length)

        const item = list[index]
        list[index] = list[randomIndex]
        list[randomIndex] = item
      })

      return list
    },

    likeSwitchLeft () {
      if (this.likeActive === 0) {
        this.likeActive = this.likeActiveMax
        return
      }
      this.likeActive = this.likeActive - 1
    },

    likeSwitchRight () {
      if (this.likeActive === this.likeActiveMax) {
        this.likeActive = 0
        return
      }
      this.likeActive = this.likeActive + 1
    },

    getLabel (tags = '') {
      return tags.split(',').filter(item => item)
    },

    computedBread () {
      const level1Item = this.listSelectItem(
        this.categoryList,
        this.matDetail[Level1]
      )
      const level2Item = this.listSelectItem(
        level1Item.list || [],
        this.matDetail[Level2]
      )
      const level3Item = this.listSelectItem(
        level2Item.list || [],
        this.matDetail[Level3]
      )

      this.breadArr = [
        { title: '首页', url: '/' },
        {
          title: level1Item.name,
          url: `/search?keyword=${encodeURIComponent(level1Item.name)}`
        },
        {
          title: level2Item.name,
          url: `/search?keyword=${encodeURIComponent(level2Item.name)}`
        },
        {
          title: level3Item.name,
          url: `/search?keyword=${encodeURIComponent(level3Item.name)}`
        },
        { title: this.matDetail.name }
      ]
    },

    listSelectItem (list, id) {
      return list.filter(item => item.id === id)?.[0] || []
    },

    clickDownloadBtn () {
      const payType = this.matDetail.pay_type
      this.report(payType !== 0 ? '立即下载' : '免费下载', 1)
      this.downloadMatCheck()
    },

    downloadMatCheck () {
      const payType = this.matDetail.pay_type
      if (!this.isLoginedIn) {
        this.$store.commit('loginDialogVisible', true)
        return
      }

      if (!this.isVip && payType !== 0) {
        this.$toast({ desc: '该模板是会员权益' })
        this.$store.dispatch('openMemberDialog')
        return
      }

      this.downLoad()
    },

    downLoad () {
      const query = this.$route.query
      const bread = this.breadArr

      api.material
        .download({
          data: { [MatId]: Number(query[MatId]), source: getSource() }
        })
        .then(res => {
          reportDownload({
            first_class: bread[1].title,
            second_class: bread[2].title,
            third_class: bread[3].title,
            ...this.templateReport
          })

          let materialUrl = res?.data?.url

          if (!materialUrl) {
            this.$toast({ desc: '抱歉，获取不到该素材，请联系管理员' })
            return
          }

          if (!materialUrl.includes('https')) {
            materialUrl = materialUrl.replace('http', 'https')
          }

          ClientDownload({
            id: this.matDetail.id + '',
            filename: this.matDetail.name + '.' + this.matDetail.format.toLocaleLowerCase(),
            type: 0,
            url: materialUrl
          })
            .then(() => {
              this.$store.commit('down/downloadDialogVisible', true)
            })
            .catch(() => {
              this.$toast({ desc: '客户端下载异常，请联系客服' })
            })
        })
        .catch(data => {
          if (data.ret === limitDownloadCode) {
            this.downloadLimitDialog = true
          } else if (retCode[String(data.ret)]) {
            this.$toast({ desc: retCode[data.ret] })
          }
        })
    },

    handleWindowScroll () {
      this.setHeaderTopStatus()
    },

    setHeaderTopStatus () {
      const parent = this.$refs.parent
      const parentRect = parent.getBoundingClientRect()
      let status = false
      const $globalHeaderEl = document.getElementsByClassName('main_header_box')[0]
      $globalHeaderEl.style.display = 'block'
      if (parentRect.top + 64 <= 0) {
        // fix: 全局搜索框失去焦点，从而隐藏搜索框的退件框，这波操作非常骚，请小心
        $globalHeaderEl.style.display = 'none'
        status = true
        // 只上报一次展示
        if (!this.isHeaderTopShowReport) {
          this.isHeaderTopShowReport = true
          reportAction({ actiontype: 1, pagetype: 4, area: 6 })
        }
      }
      this.isShowHeaderTopFixed = status
    }
  }
}
</script>

<style lang="scss" scoped>
.detail_box { width: 1202px; margin: auto; overflow: hidden;
  .detail_ad { display: inline-block; width: 100%; height: 36px; }

  .detail_bread { height: 46px; padding-bottom: 4px; line-height: 46px;}
  .detail_content { position: relative; margin-bottom: 36px; overflow: hidden; }
  .content_left { box-sizing: border-box; float:left; width: 820px }
  .content_img { min-height: 400px; padding: 36px 20px 50px 20px; background-color: #fff; border-radius: 8px;
    .left_title { margin-bottom: 36px; font-size: 24px; font-weight: 400; line-height: 28px; color: #333; }
    .left_title_free { float: left; width: 28px; height: 28px; margin-right: 8px; background-image: url(~@/assets/images/icon_detail_free.png); background-size: cover; }
    .left_title_vip { float: left; width: 48px; height: 28px; margin-right: 16px; background-image: url(~@/assets/images/icon_detail_vip.png); background-size: cover; }
  }
  .model_detail { position: relative; overflow: hidden;
    img { width: 100%; }
    .detail_mast { position: absolute; top: 0; right: 0; bottom: 0; left: 0; text-align: center;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 90%,
        rgba(255, 255, 255, 0.7) 90%,
        rgba(255, 255, 255, 0.8) 100%
      );
    }
    .mast_btn_box { position: absolute; bottom: 13px; width: 100%; font-size: 17px; font-weight: bold; color: #3484FF; text-align: center;
      .mast_btn { display: inline-block; cursor: pointer; }
      .icon_detail_down { display: inline-block; width: 12px; height: 12px; margin-left: 7px; background-image: url(~@/assets/images/icon_arrow_down.png); background-size: cover; }
    }
  }
  .detail_recommend { padding: 36px 24px 20px 24px; margin-top: 20px; background-color: #fff; border-radius: 8px;
    .recommend_title { margin-bottom: 25px; font-size: 18px; color: #666; }
    .recommend_item { margin: 0 17px 20px 0;
      &:nth-child(4n) { margin-right: 0; }
    }
  }

  .content_right { box-sizing: border-box; float: right; width: 362px; min-height: 400px; }
  .content_info { padding: 30px 41px 0 41px; background-color: #fff; border-radius: 8px;
    .right_down { margin-bottom: 20px; }
    .down_btn { width: 280px; height: 56px; font-size: 24px; font-weight: 400; color: #fff; cursor: pointer; background-color: #3484ff; border: none; border-radius: 8px; outline: none;
      &:hover { background-color: #2071ed; }
    }
    .icon_down { display: inline-block; width: 20px; height: 20px; margin-right: 20px; vertical-align: middle; background-image: url(~@/assets/images/icon_detail_download.png); background-size: cover;
      &.white { background-image: url(~@/assets/images/icon_detail_download_white.png); }
      &.black { margin-right: 14px; vertical-align: sub; }
      &.look { margin-right: 14px; vertical-align: sub; background-image: url(~@/assets/images/icon_detail_look.png); }
    }

    .top_line { border-top: 1px solid #e7e7e7; }

    .font_box { padding: 24px 0; font-size: 14px; font-weight: 400; line-height: 14px; color: #666;
      .label { float: left; }
      .font { padding-left: 76px; }
      .font_item {
        &:last-child { margin-bottom: 0; }
      }
    }
    .font_item { margin-bottom: 20px; overflow: hidden; }
  }
  .detail_like { box-sizing: border-box; width: 362px; padding: 24px 24px 10px 24px; margin-top: 20px; background-color: #fff; border-radius: 8px;
    .like_header { margin-bottom: 24px; line-height: 18px;
      .title { display: inline-block; font-size: 18px; font-weight: 400; color: #666; }

      .switch { float: right; font-size: 0;
        .left { margin-right: 8px; transform: rotate(180deg); }
      }
    }
    .like_item { margin-bottom: 10px;
      &:nth-child(2n) { margin-left: 14px; }
    }
  }

  .label_box { margin-top: 16px; }
  .label_item { display: inline-block; height: 22px; padding: 0 11px; margin: 0 8px 12px 0; line-height: 22px; cursor: pointer; border: 1px solid #666; border-radius: 10px;
    &:hover { color: $default_primary_hover; border-color: $default_primary_hover; }
    a { display: inline-block; max-width: 82px; color: inherit; text-decoration: none; }
  }
}
</style>
